import Vue from 'vue'
import '@babel/polyfill' // ie11 호환
import './plugins/fontawesome'
import './plugins/axios'
import App from './App.vue'
import store from './store'
import router from './router'
import Paginate from 'vuejs-paginate'
import itmDatepicker from '@/components/utils/datePicker.vue'
import CKEditer from '@ckeditor/ckeditor5-vue'


import './assets/css/common.css'
import './assets/css/reset.css'
import './assets/css/admin/admin_default.css'
import './assets/css/bootstrap_modal.min.css'
import './assets/css/style.css'
import './assets/js/bootstrap.js'

Vue.config.productionTip = false

// 이벤트 버스 import없이 전역으로 사용하기 위함
Vue.prototype.$EventBus = new Vue();

// 페이징 컴포넌트 전역 설정
Vue.component('Paginate', Paginate)
// DatePicker 컴포넌트 전역 설정
Vue.component('itmDatepicker', itmDatepicker)
Vue.config.silent = true
// CK에디터 전역 사용
Vue.use( CKEditer )

const myVue = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')

export default myVue